import Model from './Model';
import Collection from './Collection';

/**
 * Publication model
 */
export class Publication extends Model {

	static noLogo = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAQAAAC0NkA6AAAALUlEQVR42u3NMQEAAAgDINc/9Mzg4QcFSDvvIpFIJBKJRCKRSCQSiUQikUhuFtAOY89wCn1dAAAAAElFTkSuQmCC';

	// Default attributes that define the "empty" state.
	defaults() {
		return {
			id: null,
			name: '',
			urlId: '',
			domain: '',
			popularityAlexis: 0,
			popularityManual: 0,
			alexaLinksInCount: 0,
			alexaReachUsers: 0,
			alexaReachPercentage: 0,
			alexaReachPerMillion: 0,
			alexaRankUsa: 0,
			alexaRankGlobal: 0,
			competeUniqueMonthlyViews: 0,
			pagerank: 0,
			country: '',
			logo: Publication.noLogo,
			image: '',
			images: [],
		};
	}

	// Attribute mutations.
	mutations() {
		return {
			id: id => Number(id) || null,
			name: String,
		};
	}

	// Route configuration
	routes() {
		return {
			patch: '/publications/{id}',
			refetchMoz: '/publications/{id}/update-moz',
			refetchAlexa: '/publications/{id}/update-alexa',
			refetchSimilar: '/publications/{id}/update-similar',
			uploadImage: '/publications/{id}/upload-image',
		};
	}

	options() {
		return {
			patch: true,
			methods: {
				refetchMoz: 'GET',
				refetchAlexa: 'GET',
				refetchSimilar: 'GET',
				uploadImage: 'POST',
			},
		};
	}

	refetchStats(source) {
		const method = this.getOption(`methods.refetch${source}`);
		const route = this.getRoute(`refetch${source}`);
		const url = this.getURL(route, this.getRouteParameters());

		return new Promise((resolve, reject) => {
			this.loading = true;
			this.getRequest({ method, url, headers: { Authorization: '' } })
				.send()
				.then(({ response }) => {
					this.assign(response.data);
					resolve();
				})
				.catch((error) => {
					reject(error);
				})
				.finally(() => {
					this.loading = false;
				});
		});
	}

	refetchMoz() {
		return this.refetchStats('Moz');
	}

	refetchAlexa() {
		return this.refetchStats('Alexa');
	}

	refetchSimilar() {
		return this.refetchStats('Similar');
	}

	uploadImage(uri) {
		const method = this.getOption('methods.uploadImage');
		const route = this.getRoute('uploadImage');
		const url = this.getURL(route, this.getRouteParameters());

		return new Promise((resolve, reject) => {
			this.loading = true;
			this.getRequest({ method,
				url,
				headers: { Authorization: '' },
				data: { uri },
			})
				.send()
				.then(({ response }) => {
					this.image = response.data.image;
					this.images = response.data.images;
					resolve(response);
				}).catch((error) => {
					reject(error);
				})
				.finally(() => {
					this.loading = false;
				});
		});
	}
}

/**
 * Publications collection
 */
export class Publications extends Collection {

	// Model that is contained in this collection.
	model() {
		return Publication;
	}

	// Default attributes
	defaults() {
		return {
			search: '',
		};
	}

	// Route configuration
	routes() {
		return {
			fetch: '/publications?q={search}',
		};
	}

}

export class ReportPublications extends Collection {

	model() {
		return Publication;
	}

	defaults() {
		return {
			id: null,
		};
	}

	routes() {
		return {
			fetch: '/publications?reportId={id}',
		};
	}

}
